var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconArrow = function SvgIconArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1\xE2\x83\xA3\xEF\xB8\x8F\xE5\x9B\xBE\xE6\xA0\x87/\xE5\x88\x97\xE8\xA1\xA8/\xE7\xAE\xAD\xE5\xA4\xB4/\xE5\x90\x91\xE5\x8F\xB3/\xE7\x99\xBD\xE7\x9A\xAE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84",
    d: "M11.3588 7.47651C11.6273 7.745 11.6497 8.1664 11.4259 8.46037L11.3588 8.53717L5.70196 14.194C5.40907 14.4869 4.93419 14.4869 4.6413 14.194C4.37282 13.9255 4.35044 13.5041 4.57418 13.2102L4.6413 13.1334L9.76853 8.00613L4.6413 2.88032C4.37282 2.61183 4.35044 2.19043 4.57418 1.89646L4.6413 1.81966C4.90979 1.55117 5.33119 1.5288 5.62516 1.75254L5.70196 1.81966L11.3588 7.47651Z",
    fill: "#62657A"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-arrow.3cfd7189.svg";